// extracted by mini-css-extract-plugin
module.exports = {"desktopModal":"modal_desktopModal__uqw_d","backdrop":"modal_backdrop__JV_k_"};